export var ReplacementLoca;
(function (ReplacementLoca) {
    ReplacementLoca["amount"] = "{amount}";
    ReplacementLoca["good"] = "{good}";
    ReplacementLoca["level"] = "{level}";
    ReplacementLoca["target"] = "{target}";
    ReplacementLoca["zero_0"] = "{0}";
    ReplacementLoca["one_1"] = "{1}";
    ReplacementLoca["two_2"] = "{2}";
    ReplacementLoca["three_3"] = "{3}";
    ReplacementLoca["lang"] = "{lang}";
})(ReplacementLoca || (ReplacementLoca = {}));



//////////////////
// WEBPACK FOOTER
// ./src/utils/i18n/ReplacementLoca.ts
// module id = 20
// module chunks = 3